<template>
  <div class="fixed bottom-6 right-6 z-[1100] flex flex-col gap-2 pointer-events-none max-md:bottom-4 max-md:right-4 max-md:left-4">
    <transition-group name="toast-slide" tag="div" class="flex flex-col gap-2">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="pointer-events-auto relative overflow-hidden rounded-[16px] shadow-[0_8px_24px_rgba(0,0,0,0.1),0_2px_8px_rgba(0,0,0,0.06)] max-w-[360px] max-md:max-w-none"
        :class="{
          'bg-ink': toast.type === 'success',
          'bg-[#e53935]': toast.type === 'error',
          'bg-[#f57c00]': toast.type === 'warning'
        }">
        <div class="flex items-center gap-2.5 px-5 py-3.5 text-[13px] font-medium text-white">
          <svg v-if="toast.type === 'success'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0 opacity-70"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          <svg v-else-if="toast.type === 'error'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0 opacity-70"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
          <span class="flex-1">{{ toast.message }}</span>
          <button type="button" class="shrink-0 bg-transparent border-0 text-white/50 cursor-pointer p-0.5 rounded transition-colors duration-150 hover:text-white" @click="dismiss(toast.id)">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
        <div class="h-[2px] bg-white/20">
          <div class="h-full bg-white/40 toast-timer" :style="{ animationDuration: (toast.duration || 3000) + 'ms' }"></div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppToast',
  computed: {
    ...mapState({
      toasts: state => state.toast.toasts
    })
  },
  methods: {
    dismiss (id) {
      this.$store.dispatch('DISMISS_TOAST', id)
    }
  }
}
</script>

<style>
.toast-slide-enter-active {
  transition: all 0.3s ease;
}

.toast-slide-leave-active {
  transition: all 0.2s ease;
}

.toast-slide-enter {
  opacity: 0;
  transform: translateY(12px);
}

.toast-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.toast-timer {
  animation: toast-countdown linear forwards;
}

@keyframes toast-countdown {
  from { width: 100%; }
  to { width: 0%; }
}
</style>
